export const GENERATE_REPORT = 'GENERATE_REPORT';
export const GENERATE_PROGRAM_REPORT = 'GENERATE_PROGRAM_REPORT';
export const GENERATE_DIVISION_REPORT = 'GENERATE_DIVISION_REPORT';
export const UPDATE_EDITABLE_DATA = 'UPDATE_EDITABLE_DATA';
export const SAVE_YAMS_DATA = 'SAVE_YAMS_DATA';
export const GET_UNIT_GOALS = 'GET_UNIT_GOALS';
export const GET_PSLOS = 'GET_PSLOS';
export const GET_DIVISION_GOALS = 'GET_DIVISION_GOALS';
export const GET_DIVISION_INITIATIVE = 'GET_DIVISION_INITIATIVE';
